<template>

<div align="justify">
    <p class="h4" align="center">1С Предприятие через интернет</p>
    <div align="justify">
        <table style="width: 100%;">
            <tr>
                <td style="width: 50%;">
                    
                    <table>
                        <tr>
                            <td></td>
                            <td><strong style="color: red; font-size: x-large;">ООО "АИС"</strong></td>
                        </tr>
                        <tr>
                            <td><img alt="Телефон" src="/img/ais/phone.png" width="24"></td>
                            <td><strong style="color: blue;">+7 (8216) 76-33-06</strong></td>
                        </tr>
                        <tr>
                            <td><img alt="E-mail" src="/img/ais/e-mail.png" width="24"></td>
                            <td><strong style="color: blue;">office@ais-center.ru</strong></td>
                        </tr>
                    </table>
                    
                </td>
                <td style="width: 50%; text-align: right; padding-right: 10px;">
                    <img src="/img/1c/1cfresh.png" style="height: 80px; margin-left: 20px;">
                </td>
            </tr>
        </table>
        <br>
        
        <iframe width="100%" height="410px" src="https://1cfresh.com/a/httpextreg/hs/ExternalRegistration/iframe?promouser=extreg-119-000000000000000000001&promo=6190" seamless></iframe>
        
    </div>
    
</div>

</template>

<script>
export default {
    name: 'PageContacts',
    methods: {
        func1: function(){
            alert("+++");
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    
</style>

